import { HorizontalBar } from 'react-chartjs-2'
import 'chartjs-plugin-datalabels'
import PropTypes from 'prop-types'

import './ChartRectangeDraw'
import { getCuttedString } from '../../BuildingDashboard/BuildingEssentials/helpers'
import { getDiffDirectionSymbol } from '../../BuildingAnalytics/helpers'

const defaultData = {
  labels: [
    'Photo identification',
    'Car driver license (C-Class)',
    'Working at heights',
    'Certificate IV - Mechanical Fitter',
  ].map((name) => getCuttedString(name, 15, 13)),
  datasets: [
    {
      label: 'Expiring Soon',
      backgroundColor: '#7978EB',
      data: [12, 4, 15, 2],
    },
  ],
}

let defaultOptions = {
  cornerRadius: 5,
  plugins: {
    customScale: {
      grace: 7,
    },
    topLabels: true,
    datalabels: {
      display: true,
      color: 'white',
      anchor: 'center',
      align: 'center',
    },
  },
  legend: {
    display: false,
  },
  layout: {
    padding: {
      left: 90,
    },
  },
  scales: {
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
        display: false,
      },
    ],
    yAxes: [
      {
        ticks: {
          mirror: true,
          padding: 90,
        },
        gridLines: {
          display: false,
        },
      },
    ],
  },

  tooltips: {
    callbacks: {
      title: () => null,
      label: (tooltipItem, data) => ` ${data.labels[tooltipItem['index']]}`,
      afterLabel: function (tooltipItem, data) {
        let dataset = data['datasets'][0]
        return ` ${dataset.data[tooltipItem['index']]} ${getDiffDirectionSymbol(
          dataset.diff[tooltipItem['index']],
        )} ${dataset.diff[tooltipItem['index']]}`
      },
    },
    caretSize: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    titleFontSize: 16,
    borderColor: '#EAE9E9',
    cornerRadius: 6,
    borderWidth: 1,
    titleFontColor: '#0066ff',
    bodyFontColor: '#000',
    bodyFontSize: 14,
  },
}

const gracePlugin = {
  id: 'customScale',
  beforeLayout: (chart, options, _c) => {
    let max = Number.MIN_VALUE
    let min = Number.MAX_VALUE
    let grace = options.grace || 0

    chart.data.datasets.forEach((dataset) => {
      max = Math.max(max, Math.max(...dataset.data))
      min = Math.min(min, Math.min(...dataset.data))
    })

    chart.options.scales.xAxes[0].ticks.suggestedMax = max + grace
    chart.options.scales.xAxes[0].ticks.suggestedMin = min - grace
  },
}

const topLabelsPlagin = {
  id: 'topLabels',
  afterDatasetsDraw(chart, _args, _pluginOptions) {
    const { ctx } = chart

    chart.data.datasets[0].data.forEach((datapoint, index) => {
      const datasetData = {}
      chart.data.datasets.forEach((dataset) => {
        datasetData.value = dataset.data[index]
        datasetData.id = index
        datasetData.data = dataset._meta[1].data[index]._view
      })

      ctx.fillStyle = 'rgba (255  26, 104, 1)'
      ctx.textAlign = 'center'
      ctx.font = 'bold 12px sans-serif'
      ctx.fillStyle = 'rgba (255  26, 104, 1)'
      ctx.textAlign = 'center'

      ctx.fillText(`▲ ▼${datasetData.value}`, datasetData.data.x + 20, datasetData.data.y)
    })
  },
}

const StackBar = ({
  data = defaultData,
  options = defaultOptions,
  wrapperStyles = { width: '500px', height: '400px' },
  withPlugins,
  height = 'auto',
}) => {
  return (
    <div style={wrapperStyles}>
      <HorizontalBar
        data={data}
        options={options}
        height={height}
        plugins={withPlugins && [gracePlugin, topLabelsPlagin]}
      />
    </div>
  )
}

StackBar.propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  wrapperStyles: PropTypes.object,
  withPlugins: PropTypes.bool,
  height: PropTypes.number,
}

export default StackBar
